import {
  RouterProvider,
  createBrowserRouter,
  Navigate,
  Outlet,
  useParams,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/Custom.css";
import ErrorPage from "./pages/Error";
import HomePage from "./pages/Home";
import BlogListPage from "./pages/Blog/BlogListPage";
import BlogDetailPage from "./pages/Blog/BlogDetailPage";
import HelpSupport from "./pages/Help/HelpSupport";
import RootLayout from "./pages/Root";
import Login from "./pages/Login";
import Protected from "./components/auth/Protected";
import User from "./admin/dashboard/user/User";
import Query from "./admin/dashboard/query/Query";
import ContactUs from "./admin/dashboard/contactUs/ContactUs";
import UserItem from "./admin/dashboard/user/UserItem";
import UserRoot from "./admin/dashboard/user/UserRoot";
import QueryItem from "./admin/dashboard/query/QueryItem";
import QueryRoot from "./admin/dashboard/query/QueryRoot";
import ContactUsRoot from "./admin/dashboard/contactUs/ContactUsRoot";
import ContactUsItem from "./admin/dashboard/contactUs/ContactUsItem";
import PropertyListing from "./pages/PropertyListing";
import PropertyDetails from "./components/propertyDetails/PropertyDetails";
import AddUser from "./admin/dashboard/user/AddUser";
import EditUser from "./admin/dashboard/user/EditUser";
import ConatactUsFront from "./pages/ContactUs/ContactUs";
import { MainPassowd } from "./admin/dashboard/user/ChangePassword";
import EditUserProfile from "./admin/dashboard/userProfile/EditUserProfile";
import PropertiesByCity from "./components/propertyByCity/PropertyByCity";
import ViewPartnerLead from "./admin/dashboard/partnerLead/ViewPartnerLead";
import ViewAssociatePartner from "./admin/dashboard/associatePartner/ViewAssociatePartner";
import ViewPartnerCategory from "./admin/dashboard/partnerCategory/ViewPartnerCategory";
import ViewCustomerLead from "./admin/dashboard/customerLead/ViewCustomerLead";
import InteriorDesign from "./pages/InteriorDesign/InteriorDesign";
import PropertyServices from "./pages/PropertyServices/PropertyServices";
import ContactRoot from "./vendor/common/contact/ContactRoot";
import AddContact from "./vendor/common/contact/AddContact";
import VendorContactUs from "./vendor/common/contact/ContactUs";
import VendorContactUsItem from "./vendor/common/contact/ContactUsItem";
import EditContactUs from "./vendor/common/contact/EditContactUs";
import CityRoot from "./admin/dashboard/city/CityRoot";
import City from "./admin/dashboard/city/City";
import AddCity from "./admin/dashboard/city/AddCity";
import CityItem from "./admin/dashboard/city/CityItem";
import EditCity from "./admin/dashboard/city/EditCity";
import StateRoot from "./admin/dashboard/state/StateRoot";
import State from "./admin/dashboard/state/State";
import AddState from "./admin/dashboard/state/AddState";
import StateItem from "./admin/dashboard/state/StateItem";
import EditState from "./admin/dashboard/state/EditState";
import CountryRoot from "./admin/dashboard/country/CountryRoot";
import Country from "./admin/dashboard/country/Country";
import AddCountry from "./admin/dashboard/country/AddCountry";
import CountryItem from "./admin/dashboard/country/CountryItem";
import EditCountry from "./admin/dashboard/country/EditCountry";
import UserTypeRoot from "./admin/dashboard/userType/UserTypeRoot";
import UserType from "./admin/dashboard/userType/UserType";
import AddUserType from "./admin/dashboard/userType/AddUserType";
import UserTypeItem from "./admin/dashboard/userType/UserTypeItem";
import EditUserType from "./admin/dashboard/userType/EditUserType";
import ServiceRoot from "./admin/dashboard/services/ServiceRoot";
import Service from "./admin/dashboard/services/Service";
import AddService from "./admin/dashboard/services/AddService";
import ServiceItem from "./admin/dashboard/services/ServiceItem";
import EditService from "./admin/dashboard/services/EditService";
import PropertyPurposeRoot from "./admin/dashboard/property-purpose/PropertyPurposeRoot";
import PropertyPurpose from "./admin/dashboard/property-purpose/PropertyPurpose";
import AddPropertyPurpose from "./admin/dashboard/property-purpose/AddPropertyPurpose";
import PropertyPurposeItem from "./admin/dashboard/property-purpose/PropertyPurposeItem";
import EditPropertyPurpose from "./admin/dashboard/property-purpose/EditPropertyPurpose";
import LeasePurposeRoot from "./admin/dashboard/lease-purpose/LeasePurposeRoot";
import LeasePurpose from "./admin/dashboard/lease-purpose/LeasePurpose";
import AddLeasePurpose from "./admin/dashboard/lease-purpose/AddLeasePurpose";
import LeasePurposeItem from "./admin/dashboard/lease-purpose/LeasePurposeItem";
import EditLeasePurpose from "./admin/dashboard/lease-purpose/EditLeasePurpose";
import LeaseRoot from "./admin/dashboard/lease/LeaseRoot";
import Lease from "./admin/dashboard/lease/Lease";
import AddLease from "./admin/dashboard/lease/AddLease";
import LeaseItem from "./admin/dashboard/lease/LeaseItem";
import EditLease from "./admin/dashboard/lease/EditLease";
import LeaseNotesRoot from "./admin/dashboard/lease/LeaseNotesRoot";
import LeaseNotesPage from "./admin/dashboard/lease/LeaseNotesPage";
import PropertyStatus from "./admin/dashboard/property-status/PropertyStatus";
import PropertyStatusRoot from "./admin/dashboard/property-status/PropertyStatusRoot";
import AddPropertyStatus from "./admin/dashboard/property-status/AddPropertyStatus";
import PropertyStatusItem from "./admin/dashboard/property-status/PropertyStatusItem";
import EditPropertyStatus from "./admin/dashboard/property-status/EditPropertyStatus";
import PropertyTypeRoot from "./admin/dashboard/property-type/PropertyTypeRoot";
import PropertyType from "./admin/dashboard/property-type/PropertyType";
import AddPropertyType from "./admin/dashboard/property-type/AddPropertyType";
import PropertyTypeItem from "./admin/dashboard/property-type/PropertyTypeItem";
import EditPropertyType from "./admin/dashboard/property-type/EditPropertyType";
import AreaRoot from "./admin/dashboard/area/AreaRoot";
import Area from "./admin/dashboard/area/Area";
import AddArea from "./admin/dashboard/area/AddArea";
import AreaItem from "./admin/dashboard/area/AreaItem";
import EditArea from "./admin/dashboard/area/EditArea";
import Preference from "./admin/dashboard/my-preference/MyPreference";
import LeadManagement from "./admin/dashboard/lead-management/LeadManagement";
import LeadManagementRoot from "./admin/dashboard/lead-management/LeadManagementRoot";
import AddLeadManagement from "./admin/dashboard/lead-management/AddLeadManagement";
import LeadManagementItem from "./admin/dashboard/lead-management/LeadManagementItem";
import EditLeadManagement from "./admin/dashboard/lead-management/EditLeadManagement";
import NetworkManagementRoot from "./vendor/common/network-management/NetworkManagementRoot";
import NetworkManagement from "./vendor/common/network-management/NetworkManagement";
import AddNetworkManagement from "./vendor/common/network-management/AddNetworkManagement";
import NetworkManagementItem from "./vendor/common/network-management/NetworkManagementItem";
import EditNetworkManagement from "./vendor/common/network-management/EditNetworkManagement";
import NotificationItem from "./admin/components/notification/NotificationItem";
import NotificationsPage from "./modules/notification/NotificationsPage";
import Profile from "./admin/dashboard/userProfile/Profile";
import PaymentMessage from "./pages/PaymentMessage";
import Myspace from "./admin/dashboard/homepage/MySpace";
import MainDashboard from "./admin/dashboard/homepage/MainDashboard";
import Tab4 from "./admin/dashboard/homepage/Tab4";
import Tab5 from "./admin/dashboard/homepage/Tab5";
import Tab6 from "./admin/dashboard/homepage/Tab6";
import PropertySubTypeRoot from "./admin/dashboard/property-subtype/PropertySubTypeRoot";
import PropertySubType from "./admin/dashboard/property-subtype/PropertySubType";
import AddPropertySubType from "./admin/dashboard/property-subtype/AddPropertySubType";
import PropertySubTypeItem from "./admin/dashboard/property-subtype/PropertySubTypeItem";
import EditPropertySubType from "./admin/dashboard/property-subtype/EditPropertySubType";
import Payment from "./pages/Payment";
import AdminProtected from "./components/auth/AdminProtected";
import PartnerProtected from "./components/auth/PartnerProtected";
import AdminAndPartnerProtected from "./components/auth/AdminAndPartnerProtected";
import PartnerRoot from "./admin/dashboard/unactivepartner/PartnerRoot";
import PartnerCategoryRoot from "./admin/dashboard/partnerCategory/PartnerCategoryRoot";
import PartnerCategoryList from "./admin/dashboard/partnerCategory/PartnerCategoryList";
import AddPartnerCategory from "./admin/dashboard/partnerCategory/AddPartnerCategory";
import EditPartnerCategory from "./admin/dashboard/partnerCategory/EditPartnerCategory";
import AssociatePartnerRoot from "./admin/dashboard/associatePartner/AssociatePartnerRoot";
import AssociatePartnerList from "./admin/dashboard/associatePartner/AssociatePartnerList";
import AddAssociatePartner from "./admin/dashboard/associatePartner/AddAssociatePartner";
import EditAssociatePartner from "./admin/dashboard/associatePartner/EditAssociatePartner";

import PartnerLeadRoot from "./admin/dashboard/partnerLead/PartnerLeadRoot";
import PartnerLeadList from "./admin/dashboard/partnerLead/PartnerLeadList";
import AddPartnerLead from "./admin/dashboard/partnerLead/AddPartnerLead";
import EditPartnerLead from "./admin/dashboard/partnerLead/EditPartnerLead";
import Partner from "./admin/dashboard/unactivepartner/Partner";
import PartnerItem from "./admin/dashboard/unactivepartner/PartnerItem";
import EditPartner from "./admin/dashboard/unactivepartner/EditPartner";
import AllHomeDesire from "./admin/dashboard/allhomedesire/AllHomeDesire";
import AllHomeDesireRoot from "./admin/dashboard/allhomedesire/AllHomeDesireRoot";
import AllHomeDesireItem from "./admin/dashboard/allhomedesire/AllHomeDesireItem";
import EditAllHomeDesire from "./admin/dashboard/allhomedesire/EditAllHomeDesire";
import Policy from "./pages/Policy/Policy";
import EmailScreen from "./pages/EmailScreen";
import OTPScreen from "./pages/OTPScreen";
import ResetPasswordScreen from "./pages/ResetPasswordScreen";
import AddLandType from "../src/admin/dashboard/LandType/addLandType";
import LandType from '../src/admin/dashboard/LandType/landType';
import EditLandType from "../src/admin/dashboard/LandType/editLandType";
import LandTypeItem from "../src/admin/dashboard/LandType/landTypeItems";
import LandTypeRoot from "../src/admin/dashboard/LandType/LandTypeRoot";
import AddPropertySubSubType from "../src/admin/dashboard/property-sub-subtype/AddPropertySubSubType";
import PropertySubSubTypeRoot from "../src/admin/dashboard/property-sub-subtype/PropertySubSubTypeRoot";
import PropertySubSubType from "../src/admin/dashboard/property-sub-subtype/PropertySubSubType";
import PropertySubSubTypeItem from "../src/admin/dashboard/property-sub-subtype/PropertySubSubTypeItem";
import EditPropertySubSubType from "../src/admin/dashboard/property-sub-subtype/EditPropertySubSubType";
import GoogleAnalytics from "./components/firebase/googleAnalytics";
import BlogRoot from "./admin/dashboard/blog/blogRoot";
import Blog from "./admin/dashboard/blog/blog";
import EditBlog from "./admin/dashboard/blog/editBlog";
import BlogItem from "./admin/dashboard/blog/blogItem";
import AddBlog from "./admin/dashboard/blog/addBlog";
import HelpCenterRoot from "./admin/dashboard/helpCenter/HelpCenterRoot";
import HelpCenter from "./admin/dashboard/helpCenter/HelpCenter";
import HelpCenterItem from "./admin/dashboard/helpCenter/HelpCenterItem";
import EditHelpCenterItem from "./admin/dashboard/helpCenter/editHelpCenter";
import PromotionRoot from "./admin/dashboard/promotion/promotionRoot";
import Promotion from "./admin/dashboard/promotion/promotion";
import PromotionItem from "./admin/dashboard/promotion/PromotionItem";
import PartnerPromotion from "./admin/dashboard/promotion/promotionForm/promotionForm";
import PropertyRoot from "./admin/dashboard/propertyNew/PropertyRoot";
import Property from "./admin/dashboard/propertyNew/property";
import EditPropertyItem from "./admin/dashboard/propertyNew/EditPropertyItem";
import PropertyForm from "./admin/dashboard/propertyNew/propertyForm/propertyForm";
import PropertyItem from "./admin/dashboard/propertyNew/PropertyItem";
import Post from "./admin/dashboard/postAdmin/Posts";
import PostRoot from "./admin/dashboard/postAdmin/PostRoot";
import PostItem from './admin/dashboard/postAdmin/PostItem'
import AddPostForm from './admin/dashboard/postAdmin/postForm/AddPostForm'
import EditPostForm from "./admin/dashboard/postAdmin/postForm/EditPostForm";
import ImageBannerManagement from "./admin/dashboard/imageBannerManagement/ImageBannerManagement";
import PostsCustomerDetail from "./admin/dashboard/homepage/PostCustomer/postDetail";
import PostDiscussionDetail from "./admin/dashboard/homepage/PostCustomer/PostDiscussionDetail";
import PropertyCustomerDetail from "./admin/dashboard/homepage/PropertyCustomer/PropertyDetail";
import PropertyDiscussionDetail from "./admin/dashboard/homepage/PropertyCustomer/PropertyDiscussionDetail";
import PromoCustomerDetail from "./admin/dashboard/homepage/PromotionCustomer/PromoDetail";
import PromoDiscussionDetail from "./admin/dashboard/homepage/PromotionCustomer/PromoDiscussionDetail";
import FollowPropertyCustomerDetail from "./admin/dashboard/homepage/PropertyCustomer/followPropertyDetail";
import PropertyStagesRoot from "./admin/dashboard/property-stages/PropertyStagesRoot";
import PropertyStages from "./admin/dashboard/property-stages/PropertyStages";
import AddPropertyStages from "./admin/dashboard/property-stages/AddPropertyStages";
import PropertyStagesItem from "./admin/dashboard/property-stages/PropertyStagestem";
import EditPropertyStages from "./admin/dashboard/property-stages/EditPropertyStages";
import CatalogTypeRoot from "./admin/dashboard/CatalogType/CatalogTypeRoot";
import CatalogType from "./admin/dashboard/CatalogType/CatalogType";
import AddCatalogType from "./admin/dashboard/CatalogType/AddCatalogType";
import CatalogTypeItem from "./admin/dashboard/CatalogType/CatalogTypeItem";
import EditCatalogType from "./admin/dashboard/CatalogType/EditCatalogType";
import PartnerRegistration from "./pages/partnerRegistration/PartnerRegistration";
import UserDocuments from "./admin/dashboard/userProfile/userDocuments";
import UserPayment from "./admin/dashboard/userProfile/UserPayment/userPayment";
import AfterPayment from "./admin/dashboard/userProfile/afterPayment";
import UploadLeads from "./admin/dashboard/homepage/upload-leads/UploadLeads";
import CustomerLeadRoot from "./admin/dashboard/customerLead/CustomerLeadRoot";
import CustomerLead from "./admin/dashboard/customerLead/CustomerLead";
// eslint-disable-next-line no-unused-vars
import AddCustomerLead from "./admin/dashboard/customerLead/AddCustomerLead";
import AllServicesRoot from "./admin/dashboard/AllServices/AllServicesRoot";
import AllServices from "./admin/dashboard/AllServices/AllServices";
import AddAllServices from "./admin/dashboard/AllServices/AddAllServices";
import AllServicesItem from "./admin/dashboard/AllServices/AllServicesItem";
import EditAllServices from "./admin/dashboard/AllServices/EditAllServices";
import SubscriptionRoot from "./admin/dashboard/SubscriptionPlans/SubscriptionRoot";
import Subscription from "./admin/dashboard/SubscriptionPlans/Subscription";
import AddSubscription from "./admin/dashboard/SubscriptionPlans/AddSubscription";
import SubscriptionItem from "./admin/dashboard/SubscriptionPlans/SubscriptionItem";
import EditSubscription from "./admin/dashboard/SubscriptionPlans/EditSubscription";
import CouponsRoot from "./admin/dashboard/Coupons/CouponsRoot";
import Coupons from "./admin/dashboard/Coupons/Coupons";
import LocalBazaarRoot from "./admin/dashboard/localBazaar/LocalBazaarRoot";
import LocalBazaar from "./admin/dashboard/localBazaar/LocalBazaar";
import AddLocalBazaar from "./admin/dashboard/localBazaar/AddLocalBazaar";
import LocalBazaarItem from "./admin/dashboard/localBazaar/LocalBazaarItem";
import EditLocalBazaar from "./admin/dashboard/localBazaar/EditLocalBazaar";
import About from "./pages/About/About";
import SignUp from "./pages/SignUp";
import ProfileForm from "./pages/ProfileFormDialog/ProfileForm";
import AdminLogin from "./features/auth/adminLogin";
import AdminRouteLayout from "./admin/navigation/AdminRouteLayout";
import CustomerDashboardLayout from "./components/customer/CustomerDashboardLayout";
import CustomerLease from "./components/customer/CustomerLease";

// Customer Mobile Feature Components
import BrandAmbassadorHub from "./components/customer/brandAmbassador/BrandAmbassadorHub";
import CustomerRewardsHub from "./components/customer/rewards/CustomerRewardsHub";
import HealthiansHub from "./components/customer/healthians/HealthiansHub";
import MeetingRemindersHub from "./components/customer/reminders/MeetingRemindersHub";
import CustomerCommunitiesHub from "./components/customer/communities/CustomerCommunitiesHub";
import CustomerInvitationsHub from "./components/customer/invitations/CustomerInvitationsHub";
import CustomerServicesDirectory from "./components/customer/services/CustomerServicesDirectory";
import CustomerLocalBazaarDirectory from "./components/customer/bazaar/CustomerLocalBazaarDirectory";
import CustomerInteriorDesign from "./components/customer/interior/CustomerInteriorDesign";
import LeadsPage from "./modules/lead/LeadsPage";
import LeadFormPage from "./modules/lead/LeadFormPage";
import LeadDetailPage from "./modules/lead/LeadDetailPage";
import CustomerHelpSupport from "./components/customer/help/CustomerHelpSupport";
import CustomerPlansView from "./components/customer/plans/CustomerPlansView";

// Tools Components
import ToolsHub from "./components/tools/ToolsHub";
import KhatabookTool from "./components/tools/KhatabookTool";
import CashbookTool from "./components/tools/CashbookTool";
import ProjectLedgerTool from "./components/tools/ProjectLedgerTool";
import LeasesPage from "./modules/lease/LeasesPage";
import LeaseFormPage from "./modules/lease/LeaseFormPage";
import SharedLeasesPage from "./modules/lease/SharedLeasesPage";
import NetworkFormPage from "./features/network/NetworkFormPage";
import LeaseManagementTool from "./components/tools/LeaseManagementTool";
import ToolsRoot from "./components/tools/ToolsRoot";
import PartnerToolsRoot from "./components/partner/PartnerToolsRoot";
import { KhatabookCustomerFormPage, KhatabookTransactionFormPage } from "./components/tools/forms/KhatabookFormPages";
import { ProjectFormPage, ProjectLedgerFormPage, ProjectNoteFormPage } from "./components/tools/forms/ProjectFormPages";
import { CashbookFormPage, CashbookEntryFormPage } from "./components/tools/forms/CashbookFormPages";
import PartnerOnlyRoute from "./components/auth/PartnerOnlyRoute";
import PromotionFormPage from "./modules/promotion/PromotionFormPage";

// Partner Onboarding Flow Components & Guards
import PartnerRouteGuard from "./components/auth/PartnerRouteGuard";
import PartnerServiceGuard from "./components/auth/PartnerServiceGuard";
import PartnerDashboardLayout from "./components/partner/PartnerDashboardLayout";
import PartnerSignup from "./pages/partner/PartnerSignup";
import PartnerVerifyOtp from "./pages/partner/PartnerVerifyOtp";
import PartnerOnboarding from "./pages/partner/PartnerOnboarding";
import PartnerSubscription from "./pages/partner/PartnerSubscription";
import PartnerDocuments from "./pages/partner/PartnerDocuments";
import PartnerVerification from "./pages/partner/PartnerVerification";
import NetworkHub from "./features/network/NetworkHub";
import CustomerAgentsPage from "./features/network/CustomerAgentsPage";
import PartnersPage from "./modules/partnerNetwork/PartnersPage";
import PartnerFormPage from "./modules/partnerNetwork/PartnerFormPage";
import PartnerDetailPage from "./modules/partnerNetwork/PartnerDetailPage";
import ClientsPage from "./modules/partnerNetwork/ClientsPage";
import ClientFormPage from "./modules/partnerNetwork/ClientFormPage";
import ClientDetailPage from "./modules/partnerNetwork/ClientDetailPage";
import TeamsPage from "./modules/partnerTeam/TeamsPage";
import TeamFormPage from "./modules/partnerTeam/TeamFormPage";
import TeamDetailPage from "./modules/partnerTeam/TeamDetailPage";
import TeamMemberFormPage from "./modules/partnerTeam/TeamMemberFormPage";

// Partner Mobile Feature Components
import PartnerLeadsHub from "./components/partner/leads/PartnerLeadsHub";
import PartnerInteriorDesignHub from "./components/partner/interior/PartnerInteriorDesignHub";
import PartnerLocalBazaarHub from "./components/partner/bazaar/PartnerLocalBazaarHub";
import PartnerServicesHub from "./components/partner/services/PartnerServicesHub";
import PartnerSubscriptionHub from "./components/partner/subscription/PartnerSubscriptionHub";

const LegacyCustomerRedirect = ({ to }) => {
  const params = useParams();
  let resolvedPath = to;

  Object.keys(params).forEach((key) => {
    resolvedPath = resolvedPath.replace(`:${key}`, params[key]);
  });

  return <Navigate to={resolvedPath} replace />;
};

// Agents (partner) / Friends: add and edit open as full pages (Customer and Partner dashboards)
const CUSTOMER_NETWORK_FORM_PAGES = {
  friendNew: "/customer/friends/new",
  friendEdit: (id) => `/customer/friends/${id}/edit`,
};

// Old public article links (/:blogId/:slug) keep working: they open /blogs/:slug
const LegacyBlogRedirect = () => {
  const { blogId, slug } = useParams();
  return <Navigate to={`/blogs/${slug}`} state={{ id: blogId }} replace />;
};

// Partner Network / Partner Team pages: Partner role only (a super admin gets no bypass, unlike <Protected>)
const PartnerOnlyLayout = () => (
  <PartnerOnlyRoute>
    <Outlet />
  </PartnerOnlyRoute>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <HomePage /> },
      {
        path: "about-us",
        element: <About />,
      },
      {
        path: "policy",
        element: <Policy />,
      },
      { path: "privacy-policy", element: <Policy initialTab="privacy" /> },
      { path: "terms-and-conditions", element: <Policy initialTab="intellectual" /> },
      { path: "refund-policy", element: <Policy initialTab="payment" /> },
      { path: "help", element: <HelpSupport /> },
      { path: "blogs", element: <BlogListPage /> },
      { path: "blogs/:slug", element: <BlogDetailPage /> },
      { path: "view/all/blogs", element: <Navigate to="/blogs" replace /> },
      
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "admin-login",
        element: <AdminLogin />,
      },
      {
        path: "sign-up",
        element: <SignUp />,
      },
      {
        path: "sign-up/complete-profile",
        element: <ProfileForm />
      },
      {
        path: "Email-Screen",
        element: <EmailScreen />,
      },

      {
        path: "OTP-Screen",
        element: <OTPScreen />,
      },

      {
        path: "reset-password",
        element: <ResetPasswordScreen />,
      },

      {
        path: "property-list",
        element: <PropertyListing />,
      },
      {
        path: "property/city/:cityname",
        element: <PropertiesByCity />,
      },
      {
        path: "contactus",
        element: <ConatactUsFront />,
      },
      {
        path: "partnerreg",
        // element: <MainPartnerRegistration />,
        element: <PartnerRegistration />,
      },
      {
        path: "partnerreg/documentupload/:id",
        element: <PaymentMessage />,
      },
      {
        path: "partnerreg/documentupload/payment",
        element: <Payment />,
      },

      /* =======================================================
       * PARTNER ONBOARDING FLOW ROUTES
       * ======================================================= */
      {
        path: "partner/signup",
        element: <PartnerSignup />,
      },
      {
        path: "partner/verify-otp",
        element: <PartnerVerifyOtp />,
      },
      {
        path: "partner/onboarding",
        element: (
          <PartnerRouteGuard requireAuth={true}>
            <PartnerOnboarding />
          </PartnerRouteGuard>
        ),
      },
      {
        path: "partner/profile",
        element: (
          <PartnerRouteGuard requireAuth={true}>
            <PartnerDashboardLayout>
              <Profile />
            </PartnerDashboardLayout>
          </PartnerRouteGuard>
        ),
      },
      {
        path: "partner/services",
        element: (
          <PartnerRouteGuard requireAuth={true}>
            <PartnerOnboarding />
          </PartnerRouteGuard>
        ),
      },
      {
        path: "partner/subscription",
        element: (
          <PartnerRouteGuard requireAuth={true}>
            <PartnerSubscription />
          </PartnerRouteGuard>
        ),
      },
      {
        path: "partner/documents",
        element: (
          <PartnerRouteGuard requireAuth={true}>
            <PartnerDocuments />
          </PartnerRouteGuard>
        ),
      },
      {
        path: "partner/verification",
        element: (
          <PartnerRouteGuard requireAuth={true}>
            <PartnerVerification />
          </PartnerRouteGuard>
        ),
      },
      {
        path: "partner",
        element: (
          <Protected allowedRoles={["PARTNER"]}>
            <PartnerDashboardLayout />
          </Protected>
        ),
        children: [
          {
            index: true,
            element: <Navigate to="workspace" replace />,
          },
          {
            path: "workspace",
            element: <MainDashboard />,
            children: [
              {
                path: ":Id",
                element: <FollowPropertyCustomerDetail />,
              },
            ],
          },
          {
            path: "dashboard",
            element: <Navigate to="/partner/workspace" replace />,
          },
          {
            path: "dashboard/:Id",
            element: <LegacyCustomerRedirect to="/partner/workspace/:Id" />,
          },
          {
            path: "myspace",
            element: <Navigate to="/partner/workspace" replace />,
          },
          {
            // Partner-only: PartnerToolsRoot redirects every other role to its own dashboard
            path: "tools",
            element: <PartnerToolsRoot />,
            children: [
              { index: true, element: <ToolsHub /> },
              // Khatabook is a Customer tool: Partners land on their own Cashbook
              { path: "khatabook/*", element: <Navigate to="/partner/tools/cashbook" replace /> },
              { path: "cashbook", element: <CashbookTool /> },
              { path: "cashbook/new", element: <CashbookFormPage /> },
              { path: "cashbook/:bookId/edit", element: <CashbookFormPage /> },
              { path: "cashbook/:bookId/entries/new", element: <CashbookEntryFormPage /> },
              { path: "cashbook/:bookId/entries/:entryId/edit", element: <CashbookEntryFormPage /> },
              { path: "projects", element: <ProjectLedgerTool /> },
              { path: "projects/new", element: <ProjectFormPage /> },
              { path: "projects/:projectId/edit", element: <ProjectFormPage /> },
              { path: "projects/:projectId/ledger/new", element: <ProjectLedgerFormPage /> },
              { path: "projects/:projectId/ledger/:ledgerId/edit", element: <ProjectLedgerFormPage /> },
              { path: "projects/:projectId/notes/new", element: <ProjectNoteFormPage /> },
              { path: "projects/:projectId/notes/:noteId/edit", element: <ProjectNoteFormPage /> },
              { path: "leases", element: <LeaseManagementTool /> },
            ],
          },
          // Older short URLs keep working and land on the guarded tool pages
          { path: "khatabook", element: <Navigate to="/partner/tools/cashbook" replace /> },
          { path: "cashbook", element: <Navigate to="/partner/tools/cashbook" replace /> },
          { path: "projects", element: <Navigate to="/partner/tools/projects" replace /> },
          { path: "leases", element: <LeasesPage /> },
          { path: "leases/new", element: <LeaseFormPage /> },
          { path: "leases/:Id/edit", element: <LeaseFormPage /> },
          { path: "shared-leases", element: <SharedLeasesPage /> },
          { path: "rewards", element: <CustomerRewardsHub /> },
          { path: "help", element: <CustomerHelpSupport /> },
          {
            path: "properties",
            element: <Tab5 routeBase="/partner/properties" />,
            children: [
              {
                path: ":Id",
                element: <PropertyCustomerDetail backPath="/partner/properties" />,
              },
              {
                path: ":Id/discussion",
                element: <PropertyDiscussionDetail backPath="/partner/properties" />,
              },
            ],
          },
          {
            path: "saved",
            element: (
              <Myspace
                initialFilter="follow"
                routeBase="/partner/saved"
                showFilters={false}
                sectionTitle="Saved Properties"
              />
            ),
            children: [
              {
                path: ":Id",
                element: <FollowPropertyCustomerDetail />,
              },
            ],
          },
          {
            path: "posts",
            element: <Tab4 routeBase="/partner/posts" />,
            children: [
              {
                path: ":Id",
                element: <PostsCustomerDetail backPath="/partner/posts" />,
              },
              {
                path: ":Id/discussion",
                element: <PostDiscussionDetail backPath="/partner/posts" />,
              },
            ],
          },
          {
            path: "promotions",
            element: <Tab6 routeBase="/partner/promotions" />,
            children: [
              {
                path: ":Id",
                element: <PromoCustomerDetail backPath="/partner/promotions" />,
              },
              {
                path: ":Id/discussion",
                element: <PromoDiscussionDetail backPath="/partner/promotions" />,
              },
            ],
          },
          {
            path: "my-promotions/new",
            element: (
              <PartnerOnlyRoute>
                <PromotionFormPage />
              </PartnerOnlyRoute>
            ),
          },
          {
            path: "my-promotions/:Id/edit",
            element: (
              <PartnerOnlyRoute>
                <PromotionFormPage />
              </PartnerOnlyRoute>
            ),
          },
          {
            path: "my-promotions",
            element: <Tab6 routeBase="/partner/my-promotions" mode="mine" />,
            children: [
              {
                path: ":Id",
                element: <PromoCustomerDetail backPath="/partner/my-promotions" />,
              },
              {
                path: ":Id/discussion",
                element: <PromoDiscussionDetail backPath="/partner/my-promotions" />,
              },
            ],
          },
          {
            path: "my-properties",
            element: <Tab5 routeBase="/partner/my-properties" mode="mine" />,
            children: [
              {
                path: ":Id",
                element: <PropertyCustomerDetail backPath="/partner/my-properties" />,
              },
              {
                path: ":Id/discussion",
                element: <PropertyDiscussionDetail backPath="/partner/my-properties" />,
              },
            ],
          },
          {
            path: "my-posts",
            element: <Tab4 routeBase="/partner/my-posts" mode="mine" />,
            children: [
              {
                path: ":Id",
                element: <PostsCustomerDetail backPath="/partner/my-posts" />,
              },
              {
                path: ":Id/discussion",
                element: <PostDiscussionDetail backPath="/partner/my-posts" />,
              },
            ],
          },
          {
            path: "shared-leads",
            element: (
              <Myspace
                initialFilter="shared"
                routeBase="/partner/shared-leads"
                sectionTitle="Shared Leads"
              />
            ),
          },
          {
            path: "shared-with-me",
            element: (
              <Myspace
                initialFilter="shared"
                routeBase="/partner/shared-with-me"
                sectionTitle="Shared with Me"
              />
            ),
          },
          {
            path: "network",
            element: <NetworkHub initialTab="partners" />,
          },
          {
            element: <PartnerOnlyLayout />,
            children: [
              { path: "network/partners", element: <PartnersPage /> },
              { path: "network/partners/new", element: <PartnerFormPage /> },
              { path: "network/partners/:Id", element: <PartnerDetailPage /> },
              { path: "network/partners/:Id/edit", element: <PartnerFormPage /> },
              { path: "network/clients", element: <ClientsPage /> },
              { path: "network/clients/new", element: <ClientFormPage /> },
              { path: "network/clients/:Id", element: <ClientDetailPage /> },
              { path: "network/clients/:Id/edit", element: <ClientFormPage /> },
              { path: "team", element: <TeamsPage /> },
              { path: "team/new", element: <TeamFormPage /> },
              { path: "team/:Id", element: <TeamDetailPage /> },
              { path: "team/:Id/edit", element: <TeamFormPage /> },
              { path: "team/:Id/members/new", element: <TeamMemberFormPage /> },
            ],
          },
          // Friends and Agents now live on the Partner Network page; keep old links working
          { path: "friends/*", element: <Navigate to="/partner/network" replace /> },
          { path: "friends", element: <Navigate to="/partner/network" replace /> },
          { path: "agents/*", element: <Navigate to="/partner/network" replace /> },
          { path: "agents", element: <Navigate to="/partner/network" replace /> },
          {
            path: "teams",
            element: <NetworkHub initialTab="teams" />,
          },
          {
            path: "leads",
            element: <PartnerLeadsHub />,
          },
          {
            path: "interior-design",
            element: (
              <PartnerServiceGuard mode="interior">
                <PartnerInteriorDesignHub />
              </PartnerServiceGuard>
            ),
          },
          {
            path: "local-bazaar",
            element: <PartnerLocalBazaarHub />,
          },
          {
            path: "services",
            element: <PartnerServicesHub />,
          },
          {
            path: "subscription",
            element: <PartnerSubscriptionHub />,
          },
          {
            path: "reminders",
            element: <MeetingRemindersHub />,
          },
          {
            path: "communities",
            element: <CustomerCommunitiesHub />,
          },
          {
            path: "invitations",
            element: <CustomerInvitationsHub />,
          },
          {
            path: "profile",
            element: <Profile />,
          },
        ],
      },
      {
        path: "customer",
        element: (
          <Protected allowedRoles={["CUSTOMER"]}>
            <CustomerDashboardLayout />
          </Protected>
        ),
        children: [
          {
            index: true,
            element: <Navigate to="workspace" replace />,
          },
          {
            path: "workspace",
            element: <MainDashboard />,
            children: [
              {
                path: ":Id",
                element: <FollowPropertyCustomerDetail />,
              },
            ],
          },
          {
            path: "myspace",
            element: <Myspace routeBase="/customer/myspace" />,
            children: [
              {
                path: ":Id",
                element: <FollowPropertyCustomerDetail />,
              },
            ],
          },
          {
            path: "dashboard",
            element: <Navigate to="/customer/workspace" replace />,
          },
          {
            path: "dashboard/:Id",
            element: <LegacyCustomerRedirect to="/customer/workspace/:Id" />,
          },
          {
            path: "tools",
            element: <ToolsRoot />,
            children: [
              { index: true, element: <ToolsHub /> },
              { path: "khatabook", element: <KhatabookTool /> },
              { path: "khatabook/:bookId/customers/new", element: <KhatabookCustomerFormPage /> },
              { path: "khatabook/:bookId/customers/:customerId/edit", element: <KhatabookCustomerFormPage /> },
              { path: "khatabook/:bookId/customers/:customerId/transactions/new", element: <KhatabookTransactionFormPage /> },
              { path: "khatabook/:bookId/customers/:customerId/transactions/:txId/edit", element: <KhatabookTransactionFormPage /> },
              // Cashbook is a Partner tool
              { path: "cashbook/*", element: <Navigate to="/customer/workspace" replace /> },
              { path: "projects", element: <ProjectLedgerTool /> },
              { path: "leases", element: <LeaseManagementTool /> },
            ],
          },
          { path: "khatabook", element: <Navigate to="/customer/tools/khatabook" replace /> },
          { path: "cashbook", element: <Navigate to="/customer/workspace" replace /> },
          {
            path: "projects",
            element: <ProjectLedgerTool />,
          },
          {
            path: "leases",
            element: <LeasesPage />,
          },
          {
            path: "shared-leases",
            element: <SharedLeasesPage />,
          },
          {
            path: "leases/new",
            element: <LeaseFormPage />,
          },
          {
            path: "leases/:Id/edit",
            element: <LeaseFormPage />,
          },
          {
            path: "properties",
            element: <Tab5 routeBase="/customer/properties" />,
            children: [
              {
                path: ":Id",
                element: <PropertyCustomerDetail backPath="/customer/properties" />,
              },
              {
                path: ":Id/discussion",
                element: <PropertyDiscussionDetail backPath="/customer/properties" />,
              },
            ],
          },
          {
            path: "saved",
            element: (
              <Myspace
                initialFilter="follow"
                routeBase="/customer/saved"
                showFilters={false}
                sectionTitle="Saved Properties"
              />
            ),
            children: [
              {
                path: ":Id",
                element: <FollowPropertyCustomerDetail />,
              },
            ],
          },
          {
            path: "posts",
            element: <Tab4 routeBase="/customer/posts" />,
            children: [
              {
                path: ":Id",
                element: <PostsCustomerDetail backPath="/customer/posts" />,
              },
              {
                path: ":Id/discussion",
                element: <PostDiscussionDetail backPath="/customer/posts" />,
              },
            ],
          },

          {
            path: "promotions",
            element: <Tab6 routeBase="/customer/promotions" />,
            children: [
              {
                path: ":Id",
                element: <PromoCustomerDetail backPath="/customer/promotions" />,
              },
              {
                path: ":Id/discussion",
                element: <PromoDiscussionDetail backPath="/customer/promotions" />,
              },
            ],
          },
          {
            path: "my-properties",
            element: <Tab5 routeBase="/customer/my-properties" mode="mine" />,
            children: [
              {
                path: ":Id",
                element: <PropertyCustomerDetail backPath="/customer/my-properties" />,
              },
              {
                path: ":Id/discussion",
                element: <PropertyDiscussionDetail backPath="/customer/my-properties" />,
              },
            ],
          },
          {
            path: "my-posts",
            element: <Tab4 routeBase="/customer/my-posts" mode="mine" />,
            children: [
              {
                path: ":Id",
                element: <PostsCustomerDetail backPath="/customer/my-posts" />,
              },
              {
                path: ":Id/discussion",
                element: <PostDiscussionDetail backPath="/customer/my-posts" />,
              },
            ],
          },
          {
            path: "shared-leads",
            element: (
              <Myspace
                initialFilter="shared"
                routeBase="/customer/shared-leads"
                sectionTitle="Shared Leads"
              />
            ),
          },
          {
            path: "shared-with-me",
            element: (
              <Myspace
                initialFilter="shared"
                routeBase="/customer/shared-with-me"
                sectionTitle="Shared with Me"
              />
            ),
          },
          {
            path: "network",
            element: <NetworkHub initialTab="partners" formPages={CUSTOMER_NETWORK_FORM_PAGES} />,
          },
          {
            path: "friends",
            element: <NetworkHub initialTab="contacts" formPages={CUSTOMER_NETWORK_FORM_PAGES} />,
          },
          {
            path: "friends/new",
            element: <NetworkFormPage kind="friend" />,
          },
          {
            path: "friends/:Id/edit",
            element: <NetworkFormPage kind="friend" />,
          },
          // Read-only list of partners who added the customer; add/edit links come back here
          {
            path: "agents",
            element: <CustomerAgentsPage />,
          },
          {
            path: "agents/*",
            element: <Navigate to="/customer/agents" replace />,
          },
          {
            path: "leads",
            element: <LeadsPage />,
          },
          {
            path: "leads/new",
            element: <LeadFormPage />,
          },
          {
            path: "leads/:Id",
            element: <LeadDetailPage />,
          },
          {
            path: "leads/:Id/edit",
            element: <LeadFormPage />,
          },
          {
            path: "brand-ambassador",
            element: <BrandAmbassadorHub />,
          },
          {
            path: "rewards",
            element: <CustomerRewardsHub />,
          },
          {
            path: "healthians",
            element: <HealthiansHub />,
          },
          {
            path: "reminders",
            element: <MeetingRemindersHub />,
          },
          {
            path: "communities",
            element: <CustomerCommunitiesHub />,
          },
          {
            path: "invitations",
            element: <CustomerInvitationsHub />,
          },
          {
            path: "services",
            element: <CustomerServicesDirectory />,
          },
          {
            path: "bazaar",
            element: <CustomerLocalBazaarDirectory />,
          },
          {
            path: "interior-design",
            element: <CustomerInteriorDesign />,
          },
          {
            path: "interior-design/:Id",
            element: <CustomerInteriorDesign />,
          },
          {
            path: "help",
            element: <CustomerHelpSupport />,
          },
          {
            path: "plans",
            element: <Navigate to="/customer/rewards" replace />,
          },
          {
            path: "profile",
            element: <Profile />,
          },
        ],
      },
      {
        path: "admin",
        element: (
          <AdminProtected>
            <Myspace routeBase="/admin" />
          </AdminProtected>
        ),
        children: [
          {
            path: ":Id",
            element: (
              <AdminProtected>
                <FollowPropertyCustomerDetail backPath="/admin" />
              </AdminProtected>
            ),
          },
        ],
      },
      {
        path: "admin/posts",
        element: (
          <AdminProtected>
            <Tab4 routeBase="/admin/posts" />
          </AdminProtected>
        ),
        children: [
          {
            path: ":Id",
            element: (
              <AdminProtected>
                <PostsCustomerDetail backPath="/admin/posts" />
              </AdminProtected>
            ),
          },
          {
            path: ":Id/discussion",
            element: (
              <AdminProtected>
                <PostDiscussionDetail backPath="/admin/posts" />
              </AdminProtected>
            ),
          },
        ],
      },
      {
        path: "admin/properties",
        element: (
          <AdminProtected>
            <Tab5 routeBase="/admin/properties" />
          </AdminProtected>
        ),
        children: [
          {
            path: ":Id",
            element: (
              <AdminProtected>
                <PropertyCustomerDetail backPath="/admin/properties" />
              </AdminProtected>
            ),
          },
          {
            path: ":Id/discussion",
            element: (
              <AdminProtected>
                <PropertyDiscussionDetail backPath="/admin/properties" />
              </AdminProtected>
            ),
          },
        ],
      },
      {
        path: "admin/image-banner",
        element: (
          <AdminProtected>
            <ImageBannerManagement />
          </AdminProtected>
        ),
      },
      {
        path: "admin/promotions",
        element: (
          <AdminProtected>
            <Tab6 routeBase="/admin/promotions" />
          </AdminProtected>
        ),
        children: [
          {
            path: ":Id",
            element: (
              <AdminProtected>
                <PromoCustomerDetail backPath="/admin/promotions" />
              </AdminProtected>
            ),
          },
          {
            path: ":Id/discussion",
            element: (
              <AdminProtected>
                <PromoDiscussionDetail backPath="/admin/promotions" />
              </AdminProtected>
            ),
          },
        ],
      },
      {
        path: "admin/tools",
        element: (
          <AdminProtected>
            <AdminRouteLayout>
              <ToolsHub />
            </AdminRouteLayout>
          </AdminProtected>
        ),
      },
      {
        path: "admin/tools/khatabook",
        element: (
          <AdminProtected>
            <AdminRouteLayout>
              <KhatabookTool />
            </AdminRouteLayout>
          </AdminProtected>
        ),
      },
      {
        path: "admin/tools/cashbook",
        element: (
          <AdminProtected>
            <AdminRouteLayout>
              <CashbookTool />
            </AdminRouteLayout>
          </AdminProtected>
        ),
      },
      {
        path: "admin/tools/projects",
        element: (
          <AdminProtected>
            <AdminRouteLayout>
              <ProjectLedgerTool />
            </AdminRouteLayout>
          </AdminProtected>
        ),
      },
      {
        path: "admin/tools/leases",
        element: (
          <AdminProtected>
            <AdminRouteLayout>
              <LeaseManagementTool />
            </AdminRouteLayout>
          </AdminProtected>
        ),
      },
      {
        path: "admin/network",
        element: (
          <AdminProtected>
            <AdminRouteLayout>
              <NetworkHub initialTab="partners" />
            </AdminRouteLayout>
          </AdminProtected>
        ),
      },
      {
        path: "admin/friends",
        element: (
          <AdminProtected>
            <AdminRouteLayout>
              <NetworkHub initialTab="contacts" />
            </AdminRouteLayout>
          </AdminProtected>
        ),
      },
      {
        path: "admin/teams",
        element: (
          <AdminProtected>
            <AdminRouteLayout>
              <NetworkHub initialTab="teams" />
            </AdminRouteLayout>
          </AdminProtected>
        ),
      },
      {
        path: "network",
        element: (
          <Protected>
            <NetworkHub initialTab="partners" />
          </Protected>
        ),
      },
      {
        path: "friends",
        element: (
          <Protected>
            <NetworkHub initialTab="contacts" />
          </Protected>
        ),
      },
      {
        path: "teams",
        element: (
          <Protected>
            <NetworkHub initialTab="teams" />
          </Protected>
        ),
      },
      {
        path: "agents",
        element: (
          <Protected>
            <NetworkHub initialTab="partners" />
          </Protected>
        ),
      },
      {
        path: "tools",
        element: (
          <Protected>
            <ToolsHub />
          </Protected>
        ),
      },
      {
        path: "tools/khatabook",
        element: (
          <Protected allowedRoles={["CUSTOMER"]}>
            <KhatabookTool />
          </Protected>
        ),
      },
      {
        path: "tools/cashbook",
        element: (
          <Protected allowedRoles={["PARTNER"]}>
            <CashbookTool />
          </Protected>
        ),
      },
      {
        path: "tools/projects",
        element: (
          <Protected>
            <ProjectLedgerTool />
          </Protected>
        ),
      },
      {
        path: "tools/leases",
        element: (
          <Protected>
            <LeaseManagementTool />
          </Protected>
        ),
      },
      {
        path: "dashboard",
        element: <Navigate to="/customer/workspace" replace />,
      },
      {
        path: "dashboard/preferred",
        element: <Navigate to="/customer/saved" replace />,
      },
      {
        path: "dashboard/myspace",
        element: <Navigate to="/customer/workspace" replace />,
      },
      {
        path: "dashboard/myspace/:Id",
        element: <LegacyCustomerRedirect to="/customer/workspace/:Id" />,
      },
      {
        path: "dashboard/postDashboard",
        element: <Navigate to="/customer/posts" replace />,
      },
      {
        path: "dashboard/PostDashboard",
        element: <Navigate to="/customer/posts" replace />,
      },
      {
        path: "dashboard/postDashboard/:Id",
        element: <LegacyCustomerRedirect to="/customer/posts/:Id" />,
      },
      {
        path: "dashboard/PostDashboard/:Id",
        element: <LegacyCustomerRedirect to="/customer/posts/:Id" />,
      },
      {
        path: "dashboard/propertyDashboard",
        element: <Navigate to="/customer/properties" replace />,
      },
      {
        path: "dashboard/PropertyDashboard",
        element: <Navigate to="/customer/properties" replace />,
      },
      {
        path: "dashboard/propertyDashboard/:Id",
        element: <LegacyCustomerRedirect to="/customer/properties/:Id" />,
      },
      {
        path: "dashboard/PropertyDashboard/:Id",
        element: <LegacyCustomerRedirect to="/customer/properties/:Id" />,
      },
      {
        path: "dashboard/promotionDashboard",
        element: <Navigate to="/customer/promotions" replace />,
      },
      {
        path: "dashboard/PromotionDashboard",
        element: <Navigate to="/customer/promotions" replace />,
      },
      {
        path: "dashboard/promotionDashboard/:Id",
        element: <LegacyCustomerRedirect to="/customer/promotions/:Id" />,
      },
      {
        path: "dashboard/PromotionDashboard/:Id",
        element: <LegacyCustomerRedirect to="/customer/promotions/:Id" />,
      },
      {
        path: "interiordesign",
        element: <InteriorDesign />,
      },
      {
        path: "property-services",
        element: <PropertyServices />,
      },
      {
        path: "property-service",
        element: <Navigate to="/property-services" replace />,
      },

      {
        path: "/property/add-property",
        element: (
          <Protected>
            <PartnerServiceGuard mode="standard">
              <AdminRouteLayout>
                <PropertyForm />
              </AdminRouteLayout>
            </PartnerServiceGuard>
          </Protected>
        ),
      },

      {
        path: "/user/profile",
        element: (
          <Protected>
            <AdminRouteLayout>
              <Profile />
            </AdminRouteLayout>
          </Protected>
        ),
      },
      {
        path: "my-preference",
        element: (
          <Protected>
            <AdminRouteLayout>
              <Preference />
            </AdminRouteLayout>
          </Protected>
        ),
      },
      {
        path: "/user/edit-profile",
        element: (
          <Protected>
            <AdminRouteLayout>
              <EditUserProfile />
            </AdminRouteLayout>
          </Protected>
        ),
      },
      {
        path: "/user/upload-documents",
        element: (
          <Protected>
            <AdminRouteLayout>
              <UserDocuments />
            </AdminRouteLayout>
          </Protected>
        ),
      },
      {
        path: "/user/payment-details",
        element: (
          <Protected>
            <AdminRouteLayout>
              <UserPayment />
            </AdminRouteLayout>
          </Protected>
        ),
      },
      {
        path: "/user/upload-payment-screen-shot",
        element: (
          <Protected>
            <AdminRouteLayout>
              <AfterPayment />
            </AdminRouteLayout>
          </Protected>
        ),
      },
      {
        path: "/property-details/:id",
        element: <PropertyDetails />,
      },
      {
        path: "/notification/:id",
        element: (
          <AdminRouteLayout>
            <NotificationItem />
          </AdminRouteLayout>
        ),
      },
      {
        path: "/notification",
        element: (
          <AdminRouteLayout>
            <NotificationsPage />
          </AdminRouteLayout>
        ),
      },
      {
        path: "property",
        element: (
            <PropertyRoot />
        ),
        children: [
          {
            index: true,
            // element: <PropertyListingForm />,
            element: <Property />
          },
          {
            path: ":Id",
            id: "property-details", 
            children: [
              {
                index: true,
                element: (
                    <PropertyItem />
                ),
              },
              {
                path: "edit",
                element: <EditPropertyItem />,
              },
            ], 
          },
        ],
      },
      {
        path: "/add-property",
        element: (
          <PartnerServiceGuard mode="standard">
            <AdminRouteLayout>
              <PropertyForm />
            </AdminRouteLayout>
          </PartnerServiceGuard>
        ),
      },
      {
        path: "changepassword/:userId",
        element: (
          <Protected>
            <MainPassowd />
          </Protected>
        ),
      },
      {
        path: "user",
        element: (
          <AdminAndPartnerProtected>
            <UserRoot />
          </AdminAndPartnerProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminAndPartnerProtected>
                <User />
              </AdminAndPartnerProtected>
            ),
          },
          {
            path: "add-user",
            element: (
              <AdminAndPartnerProtected>
                <AddUser />
              </AdminAndPartnerProtected>
            ),
          },
          {
            path: ":userId",
            id: "user-details",
            children: [
              {
                index: true,
                element: (
                  <AdminAndPartnerProtected>
                    <UserItem />
                  </AdminAndPartnerProtected>
                ),
              },

              {
                path: "edit",
                element: (
                  <AdminAndPartnerProtected>
                    <EditUser />
                  </AdminAndPartnerProtected>
                ),
              },
              {
                path: "changepassword",
                element: (
                  <Protected>
                    <MainPassowd />
                  </Protected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "query",
        element: (
          <AdminProtected>
            <QueryRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <Query />
              </AdminProtected>
            ),
          },
          {
            path: ":queryId",
            id: "query-details",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <QueryItem /> 
                  </AdminProtected>
                ),
              },
              // {
              //   path: "edit",
              //   element: <EditQuery />,
              // },
            ],
          },
        ],
      },
      {
        path: "help-center",
        element: (
          <HelpCenterRoot />
        ),
        children: [
          {
            index: true,
            element: (
              <HelpCenter />
            ),
          },
          {
            path: ":Id",
            id: "help-center",
            children: [
              {
                index: true,
                element: (
                  <HelpCenterItem />
                ),
              },
              {
                path: "edit",
                element: (
                  <EditHelpCenterItem />
                ),
              },
            ],
          },
        ],
      },
      {
        path: "promotion-list",
        element: (
          <PromotionRoot/>
        ),
        children: [
          {
            index: true,
            element: (
              <Promotion />
            ),
          },
          {
            path: ":Id",
            id: "promotion-list",
            children: [
              {
                index: true,
                element: <PromotionItem />
              },
              // {
              //   path: "edit",
              //   element: (
              //     <EditPromotionItem />
              //   ),
              // },
            ],
          },
        ],
      },
      {
        path: "add-promotion",
        element: (
          <PartnerProtected>
            <AdminRouteLayout>
              <PartnerPromotion />
            </AdminRouteLayout>
          </PartnerProtected>
        ),
      },
      {
        path: "contact-us",
        element: (
          <AdminProtected>
            <ContactUsRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <ContactUs />
              </AdminProtected>
            ),
          },
          {
            path: ":contactUsId",
            id: "contactus-details",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <ContactUsItem />
                  </AdminProtected>
                ),
              },
                      ],
          },
        ],
      },
      {
        path: "customer-lead",
        element: (
          <AdminProtected>
            <CustomerLeadRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <CustomerLead />
              </AdminProtected>
            ),
          },
          {
            path: "add-lead",
            element: (
              <AdminProtected>
                <AddCustomerLead />
              </AdminProtected>
            ),
          },
          {
            path: ":id",
            element: (
              <AdminProtected>
                <ViewCustomerLead />
              </AdminProtected>
            ),
          },
        ],
      },
      {
        path: "partner-leads",
        element: (
          <AdminProtected>
            <PartnerLeadRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <PartnerLeadList />
              </AdminProtected>
            ),
          },
          {
            path: "add",
            element: (
              <AdminProtected>
                <AddPartnerLead />
              </AdminProtected>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <AdminProtected>
                <EditPartnerLead />
              </AdminProtected>
            ),
          },
          {
            path: ":id",
            element: (
              <AdminProtected>
                <ViewPartnerLead />
              </AdminProtected>
            ),
          },
        ],
      },
      {
        path: "associate-partners",
        element: (
          <AdminProtected>
            <AssociatePartnerRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <AssociatePartnerList />
              </AdminProtected>
            ),
          },
          {
            path: "add",
            element: (
              <AdminProtected>
                <AddAssociatePartner />
              </AdminProtected>
            ),
          },
          {
            path: ":id",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <ViewAssociatePartner />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditAssociatePartner />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "partner-categories",
        element: (
          <AdminProtected>
            <PartnerCategoryRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <PartnerCategoryList />
              </AdminProtected>
            ),
          },
          {
            path: "add",
            element: (
              <AdminProtected>
                <AddPartnerCategory />
              </AdminProtected>
            ),
          },
          {
            path: ":id",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <ViewPartnerCategory />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditPartnerCategory />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "partners",
        element: (
          <AdminProtected>
            <PartnerRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <Partner />
              </AdminProtected>
            ),
          },
          {
            path: "add-user",
            element: (
              <AdminAndPartnerProtected>
                <AddUser />
              </AdminAndPartnerProtected>
            ),
          },
          {
            path: ":partnerId",
            id: "partner-details",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <PartnerItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditPartner />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "allhomedesire",
        element: (
          <AdminProtected>
            <AllHomeDesireRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <AllHomeDesire />
              </AdminProtected>
            ),
          },
          {
            path: "add-user",
            element: (
              <AdminAndPartnerProtected>
                <AddUser />
              </AdminAndPartnerProtected>
            ),
          },
          {
            path: ":allhomedesireId",
            id: "all-home-desire-details",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <AllHomeDesireItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditAllHomeDesire />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },

      {
        path: "post",
        element: (
          <Protected>
            <PostRoot />
          </Protected>
        ),
        children: [
          {
            index: true,
            element: <Post />,
          },
          {
            path: "add-post",
            element: <AddPostForm />
            // element: <PostBasicPropertyForm />,
            // element: <PostOnDashboard />,
          }, 
          {
            path: ":Id",
            id: "post-details",
            children: [
              {
                index: true,
                element: (
                  <Protected>
                    <PostItem />
                  </Protected>
                ),
              },
              {
                path: "edit",
                element: <EditPostForm />,
                // element: <EditPost />,
              },
            ],
          },
        ],
      },
      {
        path: "contact",
        element: (
          <PartnerProtected>
            <ContactRoot />
          </PartnerProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <PartnerProtected>
                <VendorContactUs />
              </PartnerProtected>
            ),
          },
          {
            path: "add-contact",
            element: (
              <PartnerProtected>
                <AddContact />
              </PartnerProtected>
            ),
          },
          {
            path: ":contactId",
            id: "contact-details",
            children: [
              {
                index: true,
                element: (
                  <PartnerProtected>
                    <VendorContactUsItem />
                  </PartnerProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <PartnerProtected>
                    <EditContactUs />
                  </PartnerProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "user-type",
        element: (
          <AdminProtected>
            <UserTypeRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <UserType />
              </AdminProtected>
            ),
          },
          {
            path: "add",
            element: (
              <AdminProtected>
                <AddUserType />
              </AdminProtected>
            ),
          },
          {
            path: ":userTypeId",
            id: "userType-details",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <UserTypeItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditUserType />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "state",
        element: (
          <AdminProtected>
            <StateRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <State />
              </AdminProtected>
            ),
          },
          {
            path: "add",
            element: (
              <AdminProtected>
                <AddState />
              </AdminProtected>
            ),
          },

          {
            path: ":stateId",
            id: "state-details",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <StateItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditState />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "country",
        element: (
          <AdminProtected>
            <CountryRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <Country />
              </AdminProtected>
            ),
          },
          {
            path: "add",
            element: (
              <AdminProtected>
                <AddCountry />
              </AdminProtected>
            ),
          },
          {
            path: ":countryId",
            id: "country-details",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <CountryItem />,
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditCountry />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "service",
        element: (
          <AdminProtected>
            <ServiceRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <Service />
              </AdminProtected>
            ),
          },
          {
            path: "add-service",
            element: (
              <AdminProtected>
                <AddService />
              </AdminProtected>
            ),
          },
          {
            path: ":serviceId",
            id: "service-details",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <ServiceItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditService />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "property-purpose",
        element: (
          <AdminProtected>
            <PropertyPurposeRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <PropertyPurpose />
              </AdminProtected>
            ),
          },
          {
            path: "add-propertyPurpose",
            element: (
              <AdminProtected>
                <AddPropertyPurpose />
              </AdminProtected>
            ),
          },
          {
            path: ":propertyPurposeId",
            id: "propertyPurpose-details",

            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <PropertyPurposeItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditPropertyPurpose />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "lease-purpose",
        element: (
          <AdminProtected>
            <LeasePurposeRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <LeasePurpose />
              </AdminProtected>
            ),
          },
          {
            path: "add-leasePurpose",
            element: (
              <AdminProtected>
                <AddLeasePurpose />
              </AdminProtected>
            ),
          },
          {
            path: ":Id",
            id: "leasePurpose-details",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <LeasePurposeItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditLeasePurpose />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "lease",
        element: (
          <AdminProtected>
            <LeaseRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <Lease />
              </AdminProtected>
            ),
          },
          {
            path: "add-lease",
            element: (
              <AdminProtected>
                <AddLease />
              </AdminProtected>
            ),
          },
          {
            path: ":Id",
            id: "lease-details",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <LeaseItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditLease />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "lease-notes",
        element: (
          <AdminProtected>
            <LeaseNotesRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <LeaseNotesPage />
              </AdminProtected>
            ),
          },
        ],
      },
      {
        path: "property-status",
        element: (
          <AdminProtected>
            <PropertyStatusRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <PropertyStatus />
              </AdminProtected>
            ),
          },
          {
            path: "add-propertyStatus",
            element: (
              <AdminProtected>
                <AddPropertyStatus />
              </AdminProtected>
            ),
          },
          {
            path: ":propertyStatusId",
            id: "propertyStatus-details",

            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <PropertyStatusItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditPropertyStatus />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "property-stages",
        element: (
          <AdminProtected>
            <PropertyStagesRoot/>
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <PropertyStages/>
              </AdminProtected>
            ),
          },
          {
            path: "add-propertyStages",
            element: (
              <AdminProtected>
                <AddPropertyStages/>
              </AdminProtected>
            ),
          },
          {
            path: ":propertyStageId",
            id: "propertyStages-details",

            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <PropertyStagesItem/>
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditPropertyStages/>
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "catalog-types",
        element: (
          <AdminProtected>
            <CatalogTypeRoot/>
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <CatalogType/>
              </AdminProtected>
            ),
          }, 
          {
            path: "add-catalog-type",
            element: (
              <AdminProtected>
                <AddCatalogType/>
              </AdminProtected>
            ),
          },
          {
            path: ":Id",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <CatalogTypeItem/>
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditCatalogType/> 
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "all-services",
        element: (
          <AdminProtected>
            <AllServicesRoot/>
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <AllServices/>
              </AdminProtected>
            ),
          }, 
          {
            path: "add-all-services",
            element: (
              <AdminProtected>
                <AddAllServices/> 
              </AdminProtected>
            ),
          },
          {
            path: ":Id",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <AllServicesItem/>
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditAllServices/>
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "subscription-plans",
        element: (
          <AdminProtected>
            <SubscriptionRoot/>
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <Subscription/>
              </AdminProtected>
            ),
          }, 
          {
            path: "add-subscription-plans",
            element: (
              <AdminProtected>
                <AddSubscription/>
              </AdminProtected>
            ),
          },
          {
            path: ":Id",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <SubscriptionItem/>
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditSubscription/>
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "coupons",
        element: (
          <AdminProtected>
            <CouponsRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <Coupons />
              </AdminProtected>
            ),
          },
        ],
      },
      {
        path: "local-bazaar",
        element: (
          <AdminProtected>
            <LocalBazaarRoot/>
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <LocalBazaar/>
              </AdminProtected>
            ),
          }, 
          {
            path: "add-local-bazaar",
            element: (
              <AdminProtected>
                <AddLocalBazaar/> 
              </AdminProtected>
            ),
          },
          {
            path: ":Id",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <LocalBazaarItem/>
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditLocalBazaar/>
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "land-types",
        element: (
          <AdminProtected>
            <LandTypeRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <LandType />
              </AdminProtected>
            ),
          },
          {
            path: "add-land-type",
            element: (
              <AdminProtected>
                <AddLandType />
              </AdminProtected>
            ),
          },
          {
            path: ":landTypeId",
            // id: "land-type-details",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <LandTypeItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditLandType />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "property-type",
        element: (
          <AdminProtected>
            <PropertyTypeRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <PropertyType />
              </AdminProtected>
            ),
          },
          {
            path: "add-propertyType",
            element: (
              <AdminProtected>
                <AddPropertyType />
              </AdminProtected>
            ),
          },
          {
            path: ":propertyTypeId",
            id: "propertyType-details",

            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <PropertyTypeItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditPropertyType />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "property-subtype",
        element: (
          <AdminProtected>
            <PropertySubTypeRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <PropertySubType />
              </AdminProtected>
            ),
          },
          {
            path: "add-propertysubtype",
            element: (
              <AdminProtected>
                <AddPropertySubType />
              </AdminProtected>
            ),
          },
          {
            path: ":propertySubTypeId",
            id: "propertySubType-details",

            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <PropertySubTypeItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditPropertySubType />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },

      {
        path: "property-sub-sub-type",
        element: (
          <AdminProtected>
            <PropertySubSubTypeRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true, // Default route for this path
            element: (
              <AdminProtected>
                <PropertySubSubType />
              </AdminProtected>
            ),
          },
          {
            path: "add-property-sub-sub-type",
            element: (
              <AdminProtected>
                <AddPropertySubSubType />
              </AdminProtected>
            ),
          },
          {
            path: ":propertySubSubTypeId",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <PropertySubSubTypeItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditPropertySubSubType />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "area",
        element: (
          <AdminProtected>
            <AreaRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <Area />
              </AdminProtected>
            ),
          },
          {
            path: "add",
            element: (
              <AdminProtected>
                <AddArea />
              </AdminProtected>
            ),
          },
          {
            path: ":areaId",
            id: "area-details",

            children: [
              {
                path: ":stateId",
                element: (
                  <AdminProtected>
                    <AreaItem />,
                  </AdminProtected>
                ),
              },
              {
                path: ":stateId/edit",
                element: (
                  <AdminProtected>
                    <EditArea />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "city",
        element: (
          <AdminProtected>
            <CityRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <City />
              </AdminProtected>
            ),
          },
          {
            path: "add-city",
            element: (
              <AdminProtected>
                <AddCity />
              </AdminProtected>
            ),
          },
          {
            path: ":cityId",
            id: "city-details",

            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <CityItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditCity />
                  </AdminProtected>
                ),
              },
            ],
          },
        ],
      },
      {
        path: ":blogId/:slug",
        element: <LegacyBlogRedirect />,
      },
      {
        path: "blog",
        element: (
          <AdminProtected>
            <BlogRoot />
          </AdminProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminProtected>
                <Blog />
              </AdminProtected>
            ),
          },
          {
            path: "add-blog",
            element: (
              <AdminProtected>
                <AddBlog />
              </AdminProtected>
            ),
          },
          {
            path: ":blogId",
            id: "blog-details",
            children: [
              {
                index: true,
                element: (
                  <AdminProtected>
                    <BlogItem />
                  </AdminProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <AdminProtected>
                    <EditBlog />
                  </AdminProtected>
                ),
              },
            ],
          }, 
        ],
      },
      {
        path: "upload-leads",
        element: (
          <Protected>
            <UploadLeads />
          </Protected>
        ),
      },
      {
        path: "lead",
        element: (
          <Protected>
            <LeadManagementRoot />
          </Protected>
        ),
        children: [
          {
            index: true,
            element: <LeadManagement />,
          },
          {
            path: "add-lead",
            element: <AddLeadManagement />,
          },
          {
            path: ":leadId",
            id: "lead-details",

            children: [
              {
                index: true,
                element: (
                  <Protected>
                    <LeadManagementItem />
                  </Protected>
                ),
              },
              {
                path: "edit",
                element: <EditLeadManagement />,
              },
            ],
          },
        ],
      },

      {
        path: "network",
        element: (
          <PartnerProtected>
            <NetworkManagementRoot />
          </PartnerProtected>
        ),
        children: [
          {
            index: true,
            element: (
              <PartnerProtected>
                <NetworkManagement />
              </PartnerProtected>
            ),
          },
          {
            path: "add-network",
            element: (
              <PartnerProtected>
                <AddNetworkManagement />
              </PartnerProtected>
            ),
          },
          {
            path: ":networkId",
            id: "network-details",

            children: [
              {
                index: true,
                element: (
                  <PartnerProtected>
                    <NetworkManagementItem />
                  </PartnerProtected>
                ),
              },
              {
                path: "edit",
                element: (
                  <PartnerProtected>
                    <EditNetworkManagement />
                  </PartnerProtected>
                ),
              },
            ],
          },
        ],
      },
    ],
  },

  
]);

function App() {
  return (
    <div>
      <RouterProvider router={router} 
        fallbackElement={
          <GoogleAnalytics />
        }
      />
    </div>
  );
}

export default App;
